<template>
  <b-modal id="customer-print-invoices" class="customer-print-invoices" ref="modal" title="Imprimir Facturas"
    hide-footer>
    <div class="row form-group">
      <div class="col">
        <select id="customer_print_invoices_period" v-model="period" class="custom-select">
          <option value="day">Hoy</option>
          <option value="day_prior">Ayer</option>
          <option value="week">Esta semana</option>
          <option value="week_prior">Semana pasada</option>
          <option value="month">Este mes</option>
          <option value="month_prior">Mes pasado</option>
          <option value="trimester">Este trimestre</option>
          <option value="trimester_prior">Trimestre pasado</option>
          <option value="year">Este año</option>
          <option value="past_year">Año pasado</option>
          <option value="custom">Personalizado</option>
        </select>
        <label for="customer_print_invoices_period" class="wabident-info">Periodo</label>
      </div>

      <transition name="fade">
        <div class="col" v-if="period == 'custom'">
          <input v-model="date_from" id="customer_print_invoices_date_from" type="date" class="form-control" />
          <label class="wabident-info" for="customer_print_invoices_date_from">Desde:</label>
        </div>
      </transition>

      <transition name="fade">
        <div class="col" v-if="period == 'custom'">
          <input v-model="date_to" id="customer_print_invoices_date_to" type="date" class="form-control" />
          <label class="wabident-info" for="customer_print_invoices_date_to">Hasta:</label>
        </div>
      </transition>
    </div>

    <div class="row form-group">
      <div class="col text-center">
        <button @click="submit()" type="button" class="btn btn-primary btn-wabident">
          Imprimir
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: ['customer', 'clinic'],
  data() {
    return {
      period: 'year',
      date_from: null,
      date_to: null,
    };
  },
  methods: {
    show() {
      this.period = 'year';
      this.date_from = null;
      this.date_to = null;
      this.$refs.modal.show();
    },
    submit() {
      const query = new URLSearchParams({
        clinic_id: this.clinic.id,
        period: this.period,
        date_from: this.date_from,
        date_to: this.date_to,
      });

      const uri = `/customer/${this.customer.id}/print_invoices?` + query.toString();
      window.open(uri);
      this.$refs.modal.hide();
    },
  }
}
</script>
